export const REACTIONS = [
  'waving',
  'clap',
  'agreeing',
  'victory',
  'waving2',
  'cooldance',
];
